module.exports = __webpack_public_path__ + "static/media/login.f2692c2e.png";